module.exports = __webpack_public_path__ + "static/media/useLaptop.ac7750ca.png";